import { c as _c } from "react/compiler-runtime";
import { Box, Link } from "@chakra-ui/react";
import { defineMessages, FormattedMessage } from "react-intl";
import React from "react";
const MOBILYSIS_URL = "https://mobilysis.ch/";
const PRIVACY_POLICY_URL = `${MOBILYSIS_URL}privacy-policy`;
const ANANSI_URL = "https://anansi-solutions.net/";
const messages = defineMessages({
  footerCopyright: {
    id: "footer.copyright",
    defaultMessage: "Copyright © {year} MobiLysis Sàrl - All Rights Reserved."
  },
  footerPrivacyPolicy: {
    id: "footer.privacyPolicy",
    defaultMessage: "Privacy Policy"
  },
  footerDevelopedBy: {
    id: "footer.developedBy",
    defaultMessage: "Developed by <link>Anansi Solutions</link>."
  }
});
const currentYear = new Date().getFullYear();
interface FooterLinkProps {
  href: string;
  testId: string;
  children: React.ReactNode;
}
const FooterLink: React.FC<FooterLinkProps> = t0 => {
  const $ = _c(5);
  const {
    href,
    testId,
    children
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      base: "xs",
      lg: "sm"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== children || $[2] !== href || $[3] !== testId) {
    t2 = <Link href={href} target="_blank" rel="noopener noreferrer" fontSize={t1} color="grey.50" whiteSpace="nowrap" data-testid={testId}>{children}</Link>;
    $[1] = children;
    $[2] = href;
    $[3] = testId;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
};
export const Footer: React.FC = () => {
  const $ = _c(7);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      base: "3",
      lg: "10"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      base: "3",
      lg: "8"
    };
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      base: "2",
      lg: "4"
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <Box justifySelf="start"><FooterLink href={PRIVACY_POLICY_URL} testId="footer-privacy-policy"><FormattedMessage {...messages.footerPrivacyPolicy} /></FooterLink></Box>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <Box justifySelf="center"><FooterLink href={MOBILYSIS_URL} testId="footer-copyright"><FormattedMessage {...messages.footerCopyright} values={{
          year: currentYear
        }} /></FooterLink></Box>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      base: "xs",
      lg: "sm"
    };
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <Box as="footer" position="absolute" bottom="0" left="0" right="0" zIndex="10" px={t0} data-testid="footer"><Box bg="primary" borderTopLeftRadius="card" borderTopRightRadius="card" px={t1} py="3" display="grid" gridTemplateColumns="1fr 1fr 1fr" alignItems="center" gap={t2}>{t3}{t4}<Box fontSize={t5} color="grey.50" justifySelf="end" whiteSpace="nowrap"><FormattedMessage {...messages.footerDevelopedBy} values={{
            link: _temp
          }} /></Box></Box></Box>;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  return t6;
};
function _temp(chunks) {
  return <FooterLink href={ANANSI_URL} testId="footer-anansi-link">{chunks}</FooterLink>;
}